import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card-info" }
const _hoisted_2 = {
  key: 0,
  class: "name"
}
const _hoisted_3 = { class: "name" }
const _hoisted_4 = { class: "name-title" }
const _hoisted_5 = { class: "name-title" }
const _hoisted_6 = { class: "other" }
const _hoisted_7 = { class: "flex-row" }
const _hoisted_8 = {
  key: 1,
  class: "flex-row"
}
const _hoisted_9 = { class: "other" }
const _hoisted_10 = { class: "other" }
const _hoisted_11 = {
  key: 0,
  class: "tip"
}
const _hoisted_12 = {
  key: 1,
  class: "identification"
}
const _hoisted_13 = { class: "condition" }
const _hoisted_14 = { class: "view-exp" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_radio = _resolveComponent("van-radio")!
  const _component_van_radio_group = _resolveComponent("van-radio-group")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_picker = _resolveComponent("van-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_datetime_picker = _resolveComponent("van-datetime-picker")!
  const _component_van_area = _resolveComponent("van-area")!
  const _component_van_checkbox = _resolveComponent("van-checkbox")!
  const _component_van_uploader = _resolveComponent("van-uploader")!
  const _component_van_action_sheet = _resolveComponent("van-action-sheet")!
  const _component_layout = _resolveComponent("layout")!

  return (_openBlock(), _createBlock(_component_layout, {
    onHandleNext: _ctx.handleNext,
    isDisabled: _ctx.isDisabled,
    form: _ctx.form,
    prePathName: "id-card"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[61] || (_cache[61] = _createElementVNode("div", { class: "title" }, [
          _createTextVNode(" 身份验证 "),
          _createElementVNode("div", { class: "tips" }, "请再次确认您的身份信息无误")
        ], -1)),
        _cache[62] || (_cache[62] = _createElementVNode("div", { class: "sex" }, "性别", -1)),
        _createVNode(_component_van_field, {
          name: "sex",
          class: "sex-field",
          rules: [{ required: true, message: '请选择性别' }]
        }, {
          input: _withCtx(() => [
            _createVNode(_component_van_radio_group, {
              modelValue: _ctx.form.sex,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.sex) = $event)),
              direction: "horizontal"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sexOptions, (item) => {
                  return (_openBlock(), _createBlock(_component_van_radio, {
                    key: item.name,
                    name: item.name
                  }, {
                    icon: _withCtx(() => [
                      _createElementVNode("i", {
                        class: "iconfont icon-xuanze1",
                        style: _normalizeStyle({ color: _ctx.form.sex == item.name ? '#A79A28' : '#A5B2DC' })
                      }, null, 4)
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" " + _toDisplayString(item.text), 1)
                    ]),
                    _: 2
                  }, 1032, ["name"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        (_ctx.idKind !== 6)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", null, [
                _cache[55] || (_cache[55] = _createElementVNode("div", { class: "name-title" }, "姓", -1)),
                _createVNode(_component_van_field, {
                  name: "familyName",
                  modelValue: _ctx.form.familyName,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.familyName) = $event)),
                  modelModifiers: { trim: true },
                  placeholder: "输入姓氏",
                  class: "familyName",
                  maxlength: "20",
                  rules: [{ required: true, message: '请输入姓氏' }]
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", null, [
                _cache[56] || (_cache[56] = _createElementVNode("div", { class: "name-title" }, "名", -1)),
                _createVNode(_component_van_field, {
                  name: "givenName",
                  modelValue: _ctx.form.givenName,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.givenName) = $event)),
                  modelModifiers: { trim: true },
                  placeholder: "输入名字",
                  maxlength: "20",
                  class: "givenName",
                  rules: [{ required: true, message: '请输入名字' }]
                }, null, 8, ["modelValue"])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.isHK ? '姓(拼音/英文)' : '姓(拼音)'), 1),
            _createVNode(_component_van_field, {
              name: "familyNameSpell",
              modelValue: _ctx.form.familyNameSpell,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.familyNameSpell) = $event)),
              modelModifiers: { trim: true },
              formatter: _ctx.formatterSpell,
              placeholder: "输入姓氏",
              class: "familyName",
              maxlength: "20",
              rules: [{ required: true, pattern: _ctx.patternSpell, message: '请输入姓氏拼音(大写)' }]
            }, null, 8, ["modelValue", "formatter", "rules"])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.isHK ? '名(拼音/英文)' : '名(拼音)'), 1),
            _createVNode(_component_van_field, {
              modelValue: _ctx.form.givenNameSpell,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.givenNameSpell) = $event)),
              modelModifiers: { trim: true },
              formatter: _ctx.formatterSpell,
              name: "givenNameSpell",
              placeholder: "输入名字",
              maxlength: "20",
              class: "givenName",
              rules: [{ required: true, pattern: _ctx.patternSpell, message: '请输入名字拼音(大写)' }]
            }, null, 8, ["modelValue", "formatter", "rules"])
          ])
        ]),
        _createVNode(_component_van_cell_group, {
          title: "称谓",
          border: false
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_field, {
              name: "callValue",
              modelValue: _ctx.form.callText,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.callText) = $event)),
              modelModifiers: { trim: true },
              readonly: "",
              "right-icon": "arrow-down",
              placeholder: "选择称谓",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showCallPickerToggle(true))),
              rules: [{ required: true, message: '请选择称谓' }]
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_van_popup, {
          show: _ctx.showCallPicker,
          "onUpdate:show": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.showCallPicker) = $event)),
          round: "",
          position: "bottom"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_picker, {
              title: "请选择",
              "default-index": _ctx.form.callIdx,
              columns: _ctx.callOptions,
              onConfirm: _ctx.onCallConfirm,
              onCancel: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showCallPickerToggle(false)))
            }, null, 8, ["default-index", "columns", "onConfirm"])
          ]),
          _: 1
        }, 8, ["show"]),
        _createVNode(_component_van_cell_group, {
          title: "证件号码",
          border: false
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_field, {
              name: "idNo",
              modelValue: _ctx.form.idNo,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.idNo) = $event)),
              modelModifiers: { trim: true },
              maxlength: "20",
              formatter: _ctx.formatterIdNo,
              "format-trigger": "onBlur",
              placeholder: "输入身份证件号码",
              rules: [{ required: true, pattern: _ctx.pattern, message: '请输入正确的身份证件号码' }]
            }, null, 8, ["modelValue", "formatter", "rules"])
          ]),
          _: 1
        }),
        _createVNode(_component_van_cell_group, {
          title: "证件签发国家",
          border: false
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_field, {
              name: "certificateIssuingCountry",
              modelValue: _ctx.form.certificateIssuingCountryText,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.certificateIssuingCountryText) = $event)),
              modelModifiers: { trim: true },
              readonly: "",
              "right-icon": "arrow-down",
              placeholder: "请选择证件签发国家",
              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showCountryPickerToggle(true))),
              rules: [{ required: true, message: '请选择证件签发国家' }]
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_van_popup, {
          show: _ctx.showCountryPicker,
          "onUpdate:show": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.showCountryPicker) = $event)),
          round: "",
          position: "bottom"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_picker, {
              title: "请选择",
              "default-index": _ctx.form.certificateIssuingCountryIdx,
              columns: _ctx.nationOptions,
              onConfirm: _ctx.onIssueCountryConfirm,
              onCancel: _cache[12] || (_cache[12] = ($event: any) => (_ctx.showCountryPickerToggle(false)))
            }, null, 8, ["default-index", "columns", "onConfirm"])
          ]),
          _: 1
        }, 8, ["show"]),
        _createVNode(_component_van_cell_group, {
          title: "出生日期",
          border: false
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_field, {
              name: "birthday",
              class: "birthday",
              modelValue: _ctx.form.birthday,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.birthday) = $event)),
              readonly: "",
              placeholder: "选择出生日期",
              rules: [{ required: true, message: '请选择出生日期' }],
              onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.showDatePickerToggle(true)))
            }, {
              "right-icon": _withCtx(() => _cache[57] || (_cache[57] = [
                _createElementVNode("i", { class: "iconfont icon-icon--date" }, null, -1)
              ])),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_van_popup, {
              show: _ctx.showDatePicker,
              "onUpdate:show": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.showDatePicker) = $event)),
              round: "",
              position: "bottom"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_datetime_picker, {
                  modelValue: _ctx.currentDate,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.currentDate) = $event)),
                  type: "date",
                  title: "选择年月日",
                  formatter: _ctx.formatter,
                  onCancel: _cache[17] || (_cache[17] = ($event: any) => (_ctx.showDatePickerToggle(false))),
                  onConfirm: _ctx.onDateConfirm,
                  "min-date": _ctx.minDate,
                  "max-date": _ctx.nowDate
                }, null, 8, ["modelValue", "formatter", "onConfirm", "min-date", "max-date"])
              ]),
              _: 1
            }, 8, ["show"])
          ]),
          _: 1
        }),
        _createVNode(_component_van_cell_group, {
          title: "出生地点",
          border: false
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_field, {
              name: "birthPlace",
              modelValue: _ctx.form.birthPlace,
              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.form.birthPlace) = $event)),
              modelModifiers: { trim: true },
              placeholder: "选择出生地点",
              readonly: "",
              rules: [{ required: true, message: '请选择出生地点' }],
              "right-icon": "arrow-down",
              onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.showBirthAreaPickerToggle(true)))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_van_popup, {
              show: _ctx.showBirthAreaPicker,
              "onUpdate:show": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.showBirthAreaPicker) = $event)),
              round: "",
              position: "bottom"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_area, {
                  value: _ctx.form.birthPlaceArea,
                  "area-list": _ctx.areaList,
                  onConfirm: _ctx.onBirthAreaConfirm,
                  onCancel: _cache[21] || (_cache[21] = ($event: any) => (_ctx.showBirthAreaPickerToggle(false)))
                }, null, 8, ["value", "area-list", "onConfirm"])
              ]),
              _: 1
            }, 8, ["show"])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_6, [
          (_ctx.form.birthPlace === '其他')
            ? (_openBlock(), _createBlock(_component_van_field, {
                key: 0,
                name: "birthPlaceOther",
                modelValue: _ctx.form.birthPlaceOther,
                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.form.birthPlaceOther) = $event)),
                modelModifiers: { trim: true },
                placeholder: "输入国家、地区",
                onBlur: _cache[24] || (_cache[24] = ($event: any) => (_ctx.filterAddress(0))),
                rules: [{ required: true, message: '请输入国家、地区' }]
              }, null, 8, ["modelValue"]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_van_cell_group, {
          title: "国籍/地区",
          border: false
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_field, {
              name: "nationality",
              modelValue: _ctx.form.nationalityText,
              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.form.nationalityText) = $event)),
              modelModifiers: { trim: true },
              placeholder: "选择国籍/地区",
              onClick: _ctx.showNation,
              readonly: "",
              rules: [{ required: true, message: '请选择国籍/地区' }],
              "right-icon": "arrow-down"
            }, null, 8, ["modelValue", "onClick"]),
            _createVNode(_component_van_popup, {
              show: _ctx.showNationPicker,
              "onUpdate:show": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.showNationPicker) = $event)),
              round: "",
              position: "bottom"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_picker, {
                  title: "请选择",
                  "default-index": _ctx.form.nationalityIdx,
                  columns: _ctx.nationOptions,
                  onConfirm: _ctx.onNationConfirm,
                  onCancel: _cache[26] || (_cache[26] = ($event: any) => (_ctx.showNationPickerToggle(false)))
                }, null, 8, ["default-index", "columns", "onConfirm"])
              ]),
              _: 1
            }, 8, ["show"])
          ]),
          _: 1
        }),
        (_ctx.idKind === 1)
          ? (_openBlock(), _createBlock(_component_van_cell_group, {
              key: 1,
              title: "证件地址",
              border: false
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_field, {
                  name: "idCardAddress",
                  modelValue: _ctx.form.idCardAddress,
                  "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.form.idCardAddress) = $event)),
                  modelModifiers: { trim: true },
                  placeholder: "输入证件地址",
                  maxlength: "150",
                  rules: [{ required: true, message: '请输入证件地址' }]
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_van_cell_group, {
          title: "证件有效期",
          border: false
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              (_ctx.checked)
                ? (_openBlock(), _createBlock(_component_van_field, {
                    key: 0,
                    name: "idCardValidDateEnd",
                    modelValue: _ctx.form.idCardValidDateEnd,
                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.form.idCardValidDateEnd) = $event)),
                    readonly: "",
                    placeholder: "选择有效期",
                    rules: [{ required: true, message: '请选择有效期' }]
                  }, null, 8, ["modelValue"]))
                : (_openBlock(), _createBlock(_component_van_field, {
                    key: 1,
                    name: "idCardValidDateEnd",
                    modelValue: _ctx.form.idCardValidDateEnd,
                    "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.form.idCardValidDateEnd) = $event)),
                    readonly: "",
                    placeholder: "选择有效期",
                    rules: [{ required: true, message: '请选择有效期' }],
                    onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.showValidityToggle(true)))
                  }, {
                    "right-icon": _withCtx(() => _cache[58] || (_cache[58] = [
                      _createElementVNode("i", { class: "iconfont icon-icon--date" }, null, -1)
                    ])),
                    _: 1
                  }, 8, ["modelValue"])),
              _createVNode(_component_van_checkbox, {
                modelValue: _ctx.checked,
                "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.checked) = $event)),
                onChange: _ctx.onValidityChange
              }, {
                icon: _withCtx(() => [
                  _createElementVNode("i", {
                    class: "iconfont icon-xuanze1",
                    style: _normalizeStyle({ color: _ctx.checked ? '#A79A28' : '#A5B2DC' })
                  }, null, 4)
                ]),
                default: _withCtx(() => [
                  _cache[59] || (_cache[59] = _createTextVNode(" 长期"))
                ]),
                _: 1
              }, 8, ["modelValue", "onChange"])
            ]),
            _createVNode(_component_van_popup, {
              show: _ctx.showValidity,
              "onUpdate:show": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.showValidity) = $event)),
              round: "",
              position: "bottom"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_datetime_picker, {
                  modelValue: _ctx.currentDate2,
                  "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.currentDate2) = $event)),
                  type: "date",
                  title: "选择年月日",
                  formatter: _ctx.formatter,
                  "min-date": _ctx.nowDate,
                  "max-date": _ctx.maxDate,
                  onCancel: _cache[34] || (_cache[34] = ($event: any) => (_ctx.showValidityToggle(false))),
                  onConfirm: _ctx.onValidityConfirm
                }, null, 8, ["modelValue", "formatter", "min-date", "max-date", "onConfirm"])
              ]),
              _: 1
            }, 8, ["show"])
          ]),
          _: 1
        }),
        _createVNode(_component_van_cell_group, {
          title: "婚姻状况",
          border: false
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_field, {
              modelValue: _ctx.form.maritalText,
              "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.form.maritalText) = $event)),
              readonly: "",
              placeholder: "选择婚姻状况",
              "right-icon": "arrow-down",
              rules: [{ required: true, message: '请选择婚姻状况' }],
              onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.showMaritalPickerToggle(true)))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_van_popup, {
              show: _ctx.showMaritalPicker,
              "onUpdate:show": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.showMaritalPicker) = $event)),
              round: "",
              position: "bottom"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_picker, {
                  title: "请选择",
                  "default-index": _ctx.form.maritalIdx,
                  columns: _ctx.maritalOptions,
                  onConfirm: _ctx.onMaritalConfirm,
                  onCancel: _cache[38] || (_cache[38] = ($event: any) => (_ctx.showMaritalPickerToggle(false)))
                }, null, 8, ["default-index", "columns", "onConfirm"])
              ]),
              _: 1
            }, 8, ["show"])
          ]),
          _: 1
        }),
        _createVNode(_component_van_cell_group, {
          title: "住宅地址",
          border: false
        }, {
          default: _withCtx(() => [
            (_ctx.idKind !== 1)
              ? (_openBlock(), _createBlock(_component_van_field, {
                  key: 0,
                  name: "familyAddressPre",
                  modelValue: _ctx.form.familyAddressPre,
                  "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.form.familyAddressPre) = $event)),
                  readonly: "",
                  placeholder: "选择住宅地址",
                  "right-icon": "arrow-down",
                  onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.showAddressPickerToggle(true))),
                  rules: [{ required: true, message: '请选择住宅地址' }]
                }, null, 8, ["modelValue"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  (_ctx.addressChecked)
                    ? (_openBlock(), _createBlock(_component_van_field, {
                        key: 0,
                        name: "familyAddressPre",
                        modelValue: _ctx.form.familyAddress,
                        "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.form.familyAddress) = $event)),
                        readonly: "",
                        placeholder: "选择住宅地址"
                      }, null, 8, ["modelValue"]))
                    : (_openBlock(), _createBlock(_component_van_field, {
                        key: 1,
                        name: "familyAddressPre",
                        modelValue: _ctx.form.familyAddressPre,
                        "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.form.familyAddressPre) = $event)),
                        readonly: "",
                        placeholder: "选择住宅地址",
                        "right-icon": _ctx.addressChecked ? '' : 'arrow-down',
                        onClick: _cache[44] || (_cache[44] = ($event: any) => (_ctx.showAddressPickerToggle(true))),
                        rules: [{ required: true, message: '请选择住宅地址' }]
                      }, null, 8, ["modelValue", "right-icon"])),
                  _createVNode(_component_van_checkbox, {
                    modelValue: _ctx.addressChecked,
                    "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.addressChecked) = $event)),
                    onChange: _ctx.onAddressChange
                  }, {
                    icon: _withCtx(() => [
                      _createElementVNode("i", {
                        class: "iconfont icon-xuanze1",
                        style: _normalizeStyle({ color: _ctx.addressChecked ? '#A79A28' : '#A5B2DC' })
                      }, null, 4)
                    ]),
                    default: _withCtx(() => [
                      _cache[60] || (_cache[60] = _createTextVNode("同证件地址"))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange"])
                ])),
            _createVNode(_component_van_popup, {
              show: _ctx.showAddressPicker,
              "onUpdate:show": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.showAddressPicker) = $event)),
              round: "",
              position: "bottom"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_area, {
                  value: _ctx.form.familyAddressArea,
                  "area-list": _ctx.areaList,
                  onConfirm: _ctx.onAddressConfirm,
                  onCancel: _cache[46] || (_cache[46] = ($event: any) => (_ctx.showAddressPickerToggle(false)))
                }, null, 8, ["value", "area-list", "onConfirm"])
              ]),
              _: 1
            }, 8, ["show"])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_9, [
          (_ctx.form.familyAddressPre === '其他')
            ? (_openBlock(), _createBlock(_component_van_field, {
                key: 0,
                name: "familyAddressOther",
                modelValue: _ctx.form.familyAddressOther,
                "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.form.familyAddressOther) = $event)),
                modelModifiers: { trim: true },
                placeholder: "输入国家、地区",
                onBlur: _cache[49] || (_cache[49] = ($event: any) => (_ctx.filterAddress(1))),
                rules: [{ required: true, message: '请输入国家、地区' }]
              }, null, 8, ["modelValue"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_10, [
          (!_ctx.addressChecked || _ctx.idKind !== 1)
            ? (_openBlock(), _createBlock(_component_van_field, {
                key: 0,
                name: "familyDetailAddress",
                modelValue: _ctx.form.familyDetailAddress,
                "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.form.familyDetailAddress) = $event)),
                placeholder: "输入详细街道、楼层、门牌号",
                rules: [{ required: true, message: '请输入详细住宅地址' }]
              }, null, 8, ["modelValue"]))
            : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.idKind !== 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, _cache[63] || (_cache[63] = [
            _createElementVNode("i", { class: "iconfont icon-jingshigantanhao2" }, null, -1),
            _createTextVNode(" 需与下方提供的地址证明信息保持一致 ")
          ])))
        : _createCommentVNode("", true),
      (_ctx.isFamilyAddress)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _cache[71] || (_cache[71] = _createElementVNode("div", { class: "tips" }, "证明可为银行结单、水电费单等", -1)),
            _createVNode(_component_van_field, {
              name: "uploader",
              rules: [{ required: true, message: '请上传地址证明' }]
            }, {
              input: _withCtx(() => [
                _createVNode(_component_van_uploader, {
                  modelValue: _ctx.fileList,
                  "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.fileList) = $event)),
                  "before-read": _ctx.beforeRead,
                  accept: ".pdf,image/*",
                  "max-count": "1",
                  "preview-size": "86",
                  onClick: _ctx.uploadToApp,
                  readonly: _ctx.isApp,
                  deletable: false
                }, {
                  "preview-cover": _withCtx(() => [
                    _createElementVNode("div", {
                      class: "preview-cover",
                      onClick: _cache[51] || (_cache[51] = _withModifiers(($event: any) => (_ctx.fileDel()), ["stop"]))
                    }, _cache[64] || (_cache[64] = [
                      _createElementVNode("i", { class: "iconfont icon-cangpeitubiao_shanchu" }, null, -1)
                    ]))
                  ]),
                  default: _withCtx(() => [
                    _cache[65] || (_cache[65] = _createElementVNode("div", { class: "upload-style" }, [
                      _createElementVNode("i", { class: "iconfont icon-jia-tianchong" }),
                      _createElementVNode("p", null, "地址证明")
                    ], -1))
                  ]),
                  _: 1
                }, 8, ["modelValue", "before-read", "onClick", "readonly"])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("p", {
                  class: "sample",
                  onClick: _cache[53] || (_cache[53] = 
//@ts-ignore
(...args) => (_ctx.viewExp && _ctx.viewExp(...args)))
                }, "查看正确示例")
              ]),
              _cache[66] || (_cache[66] = _createElementVNode("div", null, "证明需具备：", -1)),
              _cache[67] || (_cache[67] = _createElementVNode("p", null, "1.发出机构", -1)),
              _cache[68] || (_cache[68] = _createElementVNode("p", null, "2.个人姓名", -1)),
              _cache[69] || (_cache[69] = _createElementVNode("p", null, "3.地址信息", -1)),
              _cache[70] || (_cache[70] = _createElementVNode("p", null, "4.发出日期在三个月以内", -1))
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_van_action_sheet, {
        show: _ctx.fileActionState,
        "onUpdate:show": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.fileActionState) = $event)),
        actions: _ctx.actionsList,
        "cancel-text": "取消",
        "close-on-click-action": "",
        onSelect: _ctx.onFileSelect
      }, null, 8, ["show", "actions", "onSelect"])
    ]),
    _: 1
  }, 8, ["onHandleNext", "isDisabled", "form"]))
}